module.exports = __webpack_public_path__ + "static/media/tech-icon-kitchen.690db3bb.svg";